export { ContactScreen as default } from '@/src/features/contact/ui/screens/ContactScreen.web'
